export function fadeView() {
  const fadeEle = document.querySelectorAll('.js-fade');

  fadeEle.forEach((target) => {
    target.classList.add('is-view');
  });
}
